import React from 'react'
import { cn } from 'design-system'

const InputLines = ({ focused, error = false }) => (
  <div
    className={cn('yd-input-lines', {
      'yd-input-lines--error': !!error,
      'yd-input-lines--focused': !!focused
    })}>
    {['b', 't', 'l', 'r'].map(dir => (
      <span
        key={dir}
        className={`yd-input-lines__line yd-input-lines__line--${dir}`}
      />
    ))}
  </div>
)

export default InputLines
